export default __webpack_public_path__ + "static/media/silver-medal.59f19903.png";